<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="['Período Movimento', 'Valor Saldo Final']"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.periodoMovimento" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorSaldoFinal ? formatValue(obj.valorSaldoFinal) : 'R$ 0,00'" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import AverageFundingBalanceRepository from '@/shared/http/repositories/business/averagefundingbalance.js'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'AverageFundingBalance',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadAverageFundingBalance(this.document)
      }
    },
    onLoadAverageFundingBalance (document) {
      loading.push()
      this.document = document
      AverageFundingBalanceRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/averagefundingbalance.vue